import axios, { AxiosResponse } from "axios"
import { useLoadingStore } from "@/store/loadingStore"
import AuthService from "@/common/services/AuthServices"

// Create a custom axios instance
const httpClient = axios.create()

const setAuthorizationHeader = (request: any) => {
  const token = AuthService.getToken() // get token from keycloak
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
}

const manageLoadingStateOnRequest = () => {
  const loadingStore = useLoadingStore()
  if (!loadingStore.preventLoading) {
    loadingStore.incrementLoadingState(Date.now().toString())
  }
}

const manageLoadingStateOnResponse = () => {
  const loadingStore = useLoadingStore()
  if (!loadingStore.preventLoading) {
    loadingStore.decrementLoadingState()
  }
  loadingStore.setPreventLoading(false)
}

// Request Interceptor
httpClient.interceptors.request.use((request) => {
  setAuthorizationHeader(request) // Set Authorization header
  manageLoadingStateOnRequest() // Manage loading state on request
  return request
})

// Response Interceptor
httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    manageLoadingStateOnResponse() // Manage loading state on response
    return response
  },
  async (error) => {
    manageLoadingStateOnResponse() // Manage loading state on error response
    return Promise.reject(error)
  }
)

export default httpClient
